export default "__VITE_ASSET__DiyvF6T4__"